'use strict';
import iziModal from 'iziModal'
import { debounce } from '../../../_js/_helper';
import {  isMobile } from '../../../_js/_helper';

export default class ImageBanner {
  constructor() {


$(document).ready(function(){




  //for showing mobile images if in mobile
  let responsiveImages = function(){
    if($('[data-original]').length){
      $('[data-original]').each(function(i,ele){
        let imageURL = $(ele).data('original');
        let isMobileDevice = screen.width < 768 ? true: false;
        if(isMobileDevice){
          imageURL = imageURL + '&size=1400';
        }
        $(ele).attr('data-original', imageURL);

      })

    }
  }
  responsiveImages();

  $(window).on('resize', debounce(function () {

    if($('[data-original]').length){
      $('[data-original]').each(function(i,ele){
        let imageURL = $(ele).data('original');
        let isMobileDevice = screen.width < 768 ? true: false;
        if(isMobileDevice){
          imageURL = imageURL + '&size=1200';
        }
        $(ele).attr('data-original', imageURL);
        //if lazy loading has loaded the image as a background image then update background image url..
        if($(ele).css('background-image') !== 'none'){
          let imageURL = $(ele).attr('data-original');
            imageURL = imageURL.split("&size=")[0];
          $(ele).css('background-image','url('+ imageURL +')');
        }
      })
    }

  }, 250));

  if($('.js-image-banner-link-wrapper').length){


    // gives each gallery a unique id
    $('.js-image-banner-link-wrapper').each(function(i,ele){
      $(ele).attr('data-modal-gallery-id', i);
      $(ele).next().find('[data-modal-gallery]').attr('data-modal-gallery', i);



    })

    var setupGalleryIzimodal = function(){
      $('.modal-gallery').each(function(i,ele){
        $(this).iziModal({
          headerColor: '#26A69A',
          width: '50%',
          overlayColor: 'rgba(0, 0, 0, 1)',
          fullscreen: true,
          width: '80%',
          transitionIn: 'fadeIn',
          transitionOut: 'fadeOut',
          arrowKeys: false,
          navigateArrows: false,
          closeButton: false,
          overlayClose: false,
          onClosed: function(){
           var galleryId = $(ele).find('[data-modal-gallery]').data('modal-gallery');
            var $slickSlider = $('[data-modal-gallery="'+ galleryId +'"]');
            $slickSlider.slick('unslick');

          },

        });
      })
    }



    $(document).on('click', '.js-image-banner-link-wrapper', function(e){
      e.preventDefault();
      let image = $(this).siblings('.modal-gallery').find('.modal-gallery-image-inner [data-image]');
      image.each(function(i, ele){
        let imageURL = $(ele).data('image');

        //this is to load mobile image sizes
        let isMobileDevice = isMobile();
        if(isMobileDevice){
          imageURL = imageURL + '&size=1400';
        }

        $(ele).attr('data-lazy', imageURL)
      })

      var galleryId = $(this).data('modal-gallery-id');
        setupGalleryIzimodal(galleryId);




        $($('[data-modal-gallery="'+ galleryId +'"]').parents('.iziModal.modal-gallery')).iziModal('open');

      var $slickSlider = $('[data-modal-gallery="'+ galleryId +'"]');


      $slickSlider.css('opacity','0');

      $slickSlider.slick({
        focusOnSelect: true,
        accessibility: true,
        speed: 700,
      });


       let firstImageUrl  = $slickSlider.find('.slick-list [data-slick-index="0"]').find('img').data('image');
        let myImgeGallery = $("<img />").attr("src", firstImageUrl + "?" + new Date().getTime());

        $(myImgeGallery).load(function() {
          setTimeout(function(){
            $slickSlider.css('opacity','1');
          }, 1000)
        });



      $(document).unbind('keyup');

      var $slides = $('.slick-slide');
      $('.modal-slider .slick-next').focus();

    })
  }

  if(true){
    function findAncestor (el, cls) {
        while ((el = el.parentElement) && !el.classList.contains(cls));
        return el;
    }

        var $detailPagePoster = $('.video-container.-detail');
        if($detailPagePoster.length){

          $detailPagePoster.on('click',function(event) {

            var modalID = $(this).data('modal-id');
            var modal2 = $('.video-js-modal-container[data-modal="'+ modalID +'"]');
            setTimeout(function(){
              modal2.focus();}
            ,100);
            modal2.iziModal({
              overlayColor: 'rgba(0, 0, 0, 1)',
              onClosed:function(){
                player.pause();
              }
            });
            modal2.iziModal('open');
          });



        }

      var updatePlayBtnPosition = function(){
        var containerHeight = $('.video-container').height()/2 - 40;
        $('.video-banner-container > .video-container .video-js .vjs-big-play-button').css('top',containerHeight);
      }
      updatePlayBtnPosition();

      $(window).on('resize', debounce(function () {
        updatePlayBtnPosition();
      }, 250));

  }


})

  }
}
